<template>
  <div class="Echarts" style="padding: 16px 0 0 16px;background: #fff;">
    <div id="main" style="width: 100%;height:100%;"></div>
  </div>
</template>

<script>
import echarts from "echarts";
export default {
  props: {
    getData: {
      type: Array,
      default: ""
    },
    getKlineData: {
      type: Array,
      default: ""
    },
    startTime: {
      type: String,
      default: ""
    },
    endTime: {
      type: String,
      default: ""
    },
    homeTitle: {
      type: String,
      default: ""
    },
    // 是否显示
     typeName: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      upColor: "#ec0000",
      downColor: "#00da3c",
      dataCount: 20,
      quoteData: []
    };
  },
  methods: {
    splitData(rawData) {
      var categoryData = [];
      var values = [];
      var volumes = [];
      for (var i = 0; i < rawData.length; i++) {
        categoryData.push(rawData[i].splice(0, 1)[0]);
        values.push(rawData[i]);
        volumes.push([
          //   i,1,1
          rawData[i][4],
          rawData[i][0] > rawData[i][1] ? 1 : -1
        ]);
      }

      return {
        categoryData: categoryData, // 时间
        values: values, // 开盘收盘数据
        volumes: volumes
      };
    },
    getInitChg(item) {
      var sign;
      if (item > 0) {
        sign = 1;
      } else {
        sign = -1;
      }
      return sign;
    },
    // [Date,Open,Close,Lowest,Highest]
    generateOHLC(rawData) {
      var categoryData = [];
      var values = [];
      var volumes = [];
      for (var i = 0; i < rawData.length; i++) {
        // categoryData.push(rawData[i].splice(0, 1)[0]);
        categoryData[i] = rawData[i].tradeTime;
        // values.push(rawData[i]);
        values[i] = [
          //   count[i].tradeTime, // 交易时间
          rawData[i].openPrice, // 开
          rawData[i].closePrice, // 收
          rawData[i].lowPrice, // 低
          rawData[i].highPrice, // 高
          rawData[i].turnOver, // 成交额
          rawData[i].volume, // 成交量
          rawData[i].raisePoint, // 涨跌
          rawData[i].openInterest, // 持仓量
          rawData[i].chg, // 涨幅
          this.getInitChg(rawData[i].chg) // 涨幅
          // this.getSign(data, i, +boxVals[openIdx], +boxVals[closeIdx], 4) // sign
        ];
        volumes.push([
          i,
          Number(rawData[i].volume),
          Number(rawData[i].chg) > 0 ? -1 : 1
        ]);
      }

      return {
        categoryData: categoryData, // 时间
        values: values, // 开盘收盘数据
        volumes: volumes
      };
    },

    calculateMA(dayCount, data) {
      var result = [];
      for (var i = 0, len = data.values.length; i < len; i++) {
        if (i < dayCount) {
          result.push("-");
          continue;
        }
        var sum = 0;
        for (var j = 0; j < dayCount; j++) {
          sum += data.values[i - j][1];
        }
        result.push(+(sum / dayCount).toFixed(3));
      }
      return result;
    },
    getSeriesData(getData, dataValue) {
      var upColor = "#ec0000";
      var downColor = "#00da3c";
      const colors = [
        "#ff4d4f",
        "#40a9ff",
        "#ff7a45",
        "#ffec3d",
        "#b37feb",
        "#ff85c0",
        "#bae637",
        "#73d13d",
        "#36cfc9",
        "#597ef7"
      ];
      var params = dataValue.values;
      var series = [
        {
          name: this.typeName?"主图指标":'',
          type: "candlestick",
          data: dataValue.values,
          itemStyle: {
            color: upColor,
            color0: downColor,
            borderColor: null,
            borderColor0: null
          },
        }
      ];

      for (let i = 0; i < getData.length; i++) {
        const dataArrySeries = [];
        const getList =
          getData[i].listHashMap[Object.keys(getData[i].listHashMap)];
        getList.map(objs => {
          let itemVlue = Number(objs.value)
            ? Number(objs.value).toFixed(3)
            : "-";
          itemVlue = itemVlue != "-" ? Number(itemVlue) : "-";
          dataArrySeries.push(itemVlue);
        });
        series.push({
          name: Object.keys(getData[i].listHashMap)[0],
          type: "line",
          symbol: "none",
          data: dataArrySeries,
          smooth: true,
          itemStyle: {
              color: colors[i]
            }
        });
      }
      series.push({
        name: "",
        type: "bar",
        xAxisIndex: 1,
        yAxisIndex: 1,
        data: dataValue.volumes
        // itemStyle: {
        //   color: upColor,
        //   color0: downColor,
        //   borderColor: null,
        //   borderColor0: null
        // }
      });
      return series;
    },
    echartsInit() {
      var myChart = this.$echarts.init(document.getElementById("main"));
      var upColor = "#ec0000";
      var downColor = "#00da3c";
      var data = this.generateOHLC(this.getData);
      var seriesData = this.getSeriesData(this.getKlineData, data);
      var option = {
          title: {
          text: this.homeTitle
        },
        backgroundColor: "#fff",
        animation: false,
        legend: {
          bottom: 10,
          left: "center",
          data: seriesData.map(item => item.name)
        },
        tooltip: {
          trigger: "axis",
          formatter: function(params) {
            var res = params[0].name;
            params.forEach(function(item) {
              if (item.seriesType == "candlestick") {
                res +=
                  "<br>" +
                  "开盘:" +
                  item.value[1] +
                  "<br>" +
                  "收盘:" +
                  item.value[2] +
                  "<br>" +
                  "最低:" +
                  item.value[3] +
                  "<br>" +
                  "最高:" +
                  item.value[4]+
                   "<br>" +
                  "成交量:" +
                  item.value[6];
              } else if (item.seriesType == "line") {
                res +=
                  "<br>" + item.marker + item.seriesName + ":" + item.value;
              }
            });
            return res;
          }
        },
        axisPointer: {
          link: { xAxisIndex: "all" },
          label: {
            backgroundColor: "#777"
          }
        },
        toolbox: {
          show: false,
          feature: {
            dataZoom: {
              yAxisIndex: false
            },
            brush: {
              type: ["lineX", "clear"]
            }
          }
        },
        brush: {
          xAxisIndex: "all",
          brushLink: "all",
          outOfBrush: {
            colorAlpha: 0.1
          }
        },
        visualMap: {
          show: false,
          seriesIndex: seriesData.length - 1, // 底部参数对应否则只有一种颜色
          dimension: 2,
          pieces: [
            {
              value: 1,
              color: downColor
            },
            {
              value: -1,
              color: upColor
            }
          ]
        },
        grid: [
          {
            left: "10%",
            right: "8%",
            height: "50%"
          },
          {
            left: "10%",
            right: "8%",
            top: "63%",
            height: "16%"
          }
        ],
        xAxis: [
          {
            type: "category",
            data: data.categoryData,
            scale: true,
           boundaryGap: ['20%', '20%'],
            axisLine: { onZero: false },
            splitLine: { show: false },
            splitNumber: 20,
            min: "dataMin",
            max: "dataMax",
            axisPointer: {
              z: 100
            }
          },
          {
            type: "category",
            gridIndex: 1,
            data: data.categoryData,
            scale: true,
            boundaryGap: ['20%', '20%'],
            axisLine: { onZero: false },
            axisTick: { show: false },
            splitLine: { show: false },
            axisLabel: { show: false },
            splitNumber: 20,
            min: "dataMin",
            max: "dataMax",
            axisPointer: {
              label: {
                formatter: params => {
                  var seriesValue = (params.seriesData[0] || {}).value;
                  return (
                    params.value +
                    (seriesValue != null
                      ? "\n" + echarts.format.addCommas(seriesValue)
                      : "")
                  );
                }
              }
            }
          }
        ],
        yAxis: [
          {
            scale: true,
            splitArea: {
              show: false // 去掉条纹色
            }
          },
          {
            scale: true,
            gridIndex: 1,
            splitNumber: 2,
            axisLabel: { show: false },
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: { show: false }
          }
        ],
        // 控制底部拖拽
        dataZoom: [
          // {
          //   type: "inside",
          //   xAxisIndex: [0, 1],
          //   start: 50,
          //   end: 100
          // },
          {
            type: "inside",
            xAxisIndex: [0, 1],
            start: this.startTime || 0,
            end: this.endTime || 100
          },
          {
            show: true,
            xAxisIndex: [0, 1],
            type: "slider",
            top: "85%",
            start: this.startTime || 0,
            end: this.endTime || 100
          }
        ],
        series: seriesData
      };
      myChart.setOption(option, true);
      // 使用刚指定的配置项和数据显示图表。
      //   myChart.setOption(option);
    },
    myChartZoom() {
      const myChart = this.$echarts.init(document.getElementById("main"));
      const than = this;
      myChart.on("datazoom", function(params) {
        params = params.batch ? params.batch[0] : params;
        than.$emit("onZoomInit", params);
      });
    }
  },
  mounted() {
    // this.echartsInit();
    this.myChartZoom();
    window.addEventListener("resize", () => {
      this.$echarts.init(document.getElementById("main")).resize();
    });
  }
};
</script>
<style lang="less" scoped>
.Echarts {
  margin: 20px 0;
  height: 100%;
  width: 100%;
}
</style>
